export default __webpack_public_path__ + "static/media/ic_united_kingdom.a8e3f96f.svg";